import React from "react";
import moment from "moment";
import { FaPlus } from "react-icons/fa";

import { PLAN_GRID_VIEWS } from "components/Plans";
import { hasClosest } from "./useStaffingTableInteractions";

/**
 * Celdas <th> de los días para las tablas de necesidades (con menú hover para
 * añadir una necesidad). Reutilizable por PlanStaffingLevels y por la tabla de
 * necesidades fraccionadas.
 */
const StaffingDayHeader = ({
	planDays,
	planGridView,
	selectedDay,
	hoveredHeaderDay,
	onDayClick,
	onHeaderMouseEnter,
	onHeaderMouseLeave,
	onHeaderAddClick,
	t,
}) =>
	planDays.map((d) => {
		const day = moment(d.day).format("dddd");
		const shortDay = moment(d.day).format("dd");
		const dayNum = moment(d.day).format("DD");

		let day_type;
		const details = d.details;
		if (details && details.length > 0) {
			if (details[0].special_day) day_type = details[0].special_day.day_type;
			if (details[0].weekday) day_type = details[0].weekday.day_type;
		}
		if (d.special_day) day_type = d.special_day.day_type;
		if (d.weekday) day_type = d.weekday.day_type;

		const color = day_type && day_type.color;
		const isHovered = hoveredHeaderDay === d.day;
		const isSimple = PLAN_GRID_VIEWS.grid === planGridView;

		return (
			<th
				className={`th-day ${selectedDay === d.day ? "selected" : ""}`}
				key={d.day}
				style={{ color: color, position: "relative" }}
				onClick={() => onDayClick(d.day)}
				onMouseEnter={() => onHeaderMouseEnter(d.day)}
				onMouseLeave={onHeaderMouseLeave}
			>
				<div className="th-wrap">
					<span className="span-day">{isSimple ? shortDay : day}</span>
					<span className="span-num">{dayNum}</span>
				</div>
				{isHovered && onHeaderAddClick && (
					<div
						className="staffing-header-hover-menu"
						onMouseEnter={(e) => {
							e.stopPropagation();
							onHeaderMouseEnter(d.day);
						}}
						onMouseLeave={(e) => {
							const relatedTarget = e.relatedTarget;
							if (
								!relatedTarget ||
								(!hasClosest(relatedTarget, ".staffing-header-hover-menu") &&
									!hasClosest(relatedTarget, ".th-day"))
							) {
								onHeaderMouseLeave(e);
							}
						}}
					>
						<button
							className="btn-hover-action btn-add"
							onClick={(e) => {
								e.stopPropagation();
								onHeaderAddClick(d);
							}}
							onMouseEnter={(e) => {
								e.stopPropagation();
								onHeaderMouseEnter(d.day);
							}}
							title={t("plan.staffingHeader.assignNeeds")}
						>
							<FaPlus />
						</button>
					</div>
				)}
			</th>
		);
	});

export default StaffingDayHeader;
